import { render } from "./invoicedraft.vue?vue&type=template&id=83120894"
import script from "./invoicedraft.vue?vue&type=script&lang=js"
export * from "./invoicedraft.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__